"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _dayBar = _interopRequireDefault(require("./dataPicker/dayBar"));
var _dayBar2 = _interopRequireDefault(require("./dataPicker/dayBar2"));
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    dayBar: _dayBar.default,
    dayBar2: _dayBar2.default
  },
  props: ["nowtime", "width", "droupdown", "terminalbox", "source", "statistics"],
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)({
    device: function device(state) {
      return state.app.device;
    },
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        mobile: this.device === "mobile"
      };
    },
    isMobile: function isMobile() {
      return this.device === "mobile";
    },
    boxWidth: function boxWidth() {
      return this.isMobile ? "calc(100vw - 90px)" : "calc(100vw - 70px - " + this.sidebar.sidebarWidth + "px)";
    }
  }),
  data: function data() {
    return {
      checked_terminal: null,
      //用户类型选择
      terminal: [],
      nowTime: "",
      command: "实时",
      //时间范围选择
      source_list: [],
      checked_source: ""
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.$refs.headwidth.style.width = this.width;
  },
  methods: {}
};